<template>
    <div class="compare-control">
        <div class="compare-control__plans">       
            <div v-for="(plan, idx) in plans" class="compare-control__plan" :key="idx">
                <div class="compare-control__plan--filled">
                    {{getPlan(plan).title}}
                    <a class="close" href="#" @click.prevent="remove(idx)"></a>
                </div>
            </div><!--compare-control__plan-->
            
            <div v-for="(slot, idx) in remainingSlots()" :key="'s-' + idx" class="compare-control__plan">
                <div></div>
            </div><!--compare-control__plan-->
        </div><!--/compare-control__plans-->
        
        <div class="compare-control__actions">
            <button class="compare-control__button compare-control__button--blue" href="#" @click="compare" :disabled="!plans.length">{{app.labels.COMPARE}}</button>
            <a class="compare-control__button compare-control__button--simple" href="#" @click.prevent="cancel">{{app.labels.CANCEL}}</a>
        </div><!--/compare-control__actions-->

        <div class="compare-control__mobile-actions">
            <div>
                <a class="compare-control__mobile-actions__cancel" href="#" @click.prevent="cancel">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 197.402 197.402"><path fill="#ffffff" d="M146.883 197.402L45.255 98.698 146.883 0l5.265 5.418-96.039 93.28 96.039 93.282z"/></svg>
                </a>
                <span>{{plans.length}} {{app.labels.PLANS_SELECTED}}</span>
            </div>
            <button class="compare-control__mobile-actions__compare" href="#" @click="compare" :disabled="!plans.length">Compare</button>
        </div><!--/compare-control__actions-->
    </div>
</template>

<script type="text/javascript">
import {mapState, mapActions} from 'vuex'
import {range} from 'utility'
import {PLAN_LIMIT} from '../constants'

export default {
    data () {
        return {
            app: window.app,
            activePlans: window.activePlans,
            defaultPlan: window.defaultPlan
        }
    },
    computed: {
        ...mapState([
            'plans'
        ])
    },
    mounted () {
        let defaultPlan = typeof this.defaultPlan !== 'undefined' ? this.defaultPlan[0].id : this.activePlans[0].id
    
        this.updatePlans(
            [defaultPlan]
        )
    },
    methods: {
        ...mapActions([
            'updatePlans',
            'removePlan',
            'updateComparing',
            'updateCompareMode'
        ]),
        compare (value) {
            this.updateComparing(
                typeof value !== 'undefined' ? value : true
            )
        },     
        cancel () {
            this.updatePlans([])
            this.updateCompareMode(false)
        },
        remove(index) {
            this.removePlan(index)
        },
        getPlan(id) {
            return this.activePlans.find(i => i.id === id)
        },     
        remainingSlots() {
            return range(
                Math.abs(this.plans.length - PLAN_LIMIT)
            )
        }
    }
}
</script>